import React, { useEffect } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { IsNotEmpty } from 'class-validator';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { loadScript } from '@cp/utils/browser/script';
import { PaymentCardForm, PaymentCardModel, paymentCardValidationResolver } from 'src/entities/paymentMethod';
import { useCloudpaymentsCryptogram } from '../lib';

export class CloudpaymentsCardFormModel {
  @IsNotEmpty()
  cryptogram: string;
}

interface CloudpaymentsCardFormProps extends BoxProps {
  collapsable?: boolean;
}
export const CloudpaymentsCardForm: React.FC<CloudpaymentsCardFormProps> = ({ collapsable, ...props }) => {
  const form = useFormContext<CloudpaymentsCardFormModel>();
  const paymentCardForm = useForm<PaymentCardModel>({
    resolver: paymentCardValidationResolver,
  });
  const createCryptogram = useCloudpaymentsCryptogram();

  useEffect(() => {
    loadScript('https://checkout.cloudpayments.ru/checkout.js');
  }, []);

  useEffect(() => {
    const dirty = Object.keys(paymentCardForm.formState.dirtyFields).length;
    if (paymentCardForm.formState.isValid && dirty) {
      const values = paymentCardForm.getValues();
      paymentCardForm.reset(values, { keepValues: true, keepDirtyValues: false, keepDirty: false });
      createCryptogram({
        cardNumber: values.cardNumber,
        expDateMonthYear: values.expDate,
        cvv: values.cvv,
      })
        .then((cryptogram) => form.setValue('cryptogram', cryptogram, { shouldValidate: true }))
        .catch(() => {
          form.setError('cryptogram', { type: 'manual', message: 'Проверьте правильность данных' });
          paymentCardForm.setError('root', { type: 'manual', message: 'Проверьте правильность данных' });
        });
    }
  }, [form, paymentCardForm, paymentCardForm.formState, createCryptogram]);

  return (
    <Box {...props}>
      <FormProvider {...paymentCardForm}>
        <PaymentCardForm as="fieldset" collapsable={collapsable} />
      </FormProvider>
      <input type="hidden" {...form.register('cryptogram')} />
    </Box>
  );
};
